import { REGISTRIES, REGISTRY_BLURB } from "../data/content";

export function Registry() {
  return (
    <section id="registry" className="section section--tinted">
      <div className="container container--880 registry">
        <p className="eyebrow">Registry</p>
        <h2 className="h2 h2--tight" style={{ marginTop: "var(--s2)" }}>
          Gifts
        </h2>
        <p className="body registry__blurb">{REGISTRY_BLURB}</p>

        <div className="grid grid--gap24 auto-220">
          {REGISTRIES.map((item) => (
            <a
              className="registry__card"
              key={item.name}
              href={item.url}
              target="_blank"
              rel="noreferrer"
            >
              <span className="registry__name">{item.name}</span>
              <span className="registry__detail">{item.detail}</span>
              <span className="eyebrow registry__cta">View registry</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
